function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getLocaleMap, setLocaleMap } from "./store";
export function registry(localeMap) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'current';
  var strings = getLocaleMap(locale);

  var newStrings = _objectSpread(_objectSpread({}, strings), localeMap);

  setLocaleMap(newStrings, locale);
}
export var formatMessage = function formatMessage(des, variable, options) {
  var space = options === null || options === void 0 ? void 0 : options.name;
  var id = des.id,
      defaultMessage = des.defaultMessage;
  var localMap = getLocaleMap(space); // 空文案时也是用默认文案

  var defaultString = (localMap[id] === void 0 || localMap[id] === '' ? defaultMessage : localMap[id]) || '';

  if (variable && _typeof(variable) === 'object') {
    // 支持字符串变量
    defaultString = defaultString.replace(/\{([^}]+)\}/g, function () {
      var propsName = arguments.length <= 1 ? undefined : arguments[1];

      if (typeof variable[propsName] === 'undefined') {
        return arguments.length <= 0 ? undefined : arguments[0];
      }

      return variable[propsName];
    });
  }

  return defaultString;
};
export var format = formatMessage;
export var get = function get(key, defaultMessage, variable, options) {
  return formatMessage({
    id: key,
    defaultMessage: defaultMessage
  }, variable, options);
};
export var fm = get;